/** Locales the product ships. Arabic is the default and comes first. */
export const LOCALES = ['ar', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

/** Arabic is the product's default and fallback language. */
export const DEFAULT_LOCALE: Locale = 'ar';

/** Text directionality per locale, so the UI never hardcodes a guess. */
export const LOCALE_DIRECTION: Record<Locale, 'rtl' | 'ltr'> = {
  ar: 'rtl',
  en: 'ltr',
};
